import {match} from 'ts-pattern';

import {ACCOUNT_CODES} from '../constants/ACCOUNT_CODES';
import {CONFIGURATION_CODES} from '../constants/CONFIGURATION_CODES';
import {CONSENT_CODES} from '../constants/CONSENT_CODES';
import {TENANT_CODES} from '../constants/TENANT_CODES';
import {ErrorCategory} from '../types/ErrorCategory';

export const getErrorCategory = (code: string): ErrorCategory =>
  match(code)
    .when(
      (c) => CONSENT_CODES.includes(c),
      () => 'consent' as const
    )
    .when(
      (c) => TENANT_CODES.includes(c),
      () => 'tenant' as const
    )
    .when(
      (c) => ACCOUNT_CODES.includes(c),
      () => 'account' as const
    )
    .when(
      (c) => CONFIGURATION_CODES.includes(c),
      () => 'configuration' as const
    )
    .otherwise(() => 'unknown' as const);
